export default __webpack_public_path__ + "static/media/user-c.42c016ac.png";